import { type, Entity, validatedResource, association, resource, repository } from 'aurelia-orm';
import { ValidationRules } from 'aurelia-validation';
//import { TagRepository } from 'data/service/tag-repository';
import { autoinject } from 'aurelia-framework';
import { validateCompare } from "../customRules/compareValidation";


@resource('stat-info')
export class StatInfo extends Entity {

	folderCount: number;
	taskCount: number;
	kanbanCount: number;
	
}